<div mat-dialog-title>
  {{ title }}
</div>
<div mat-dialog-content>
  <p>{{ text }}</p>
</div>
<mat-dialog-actions>
  <button [mat-dialog-close]="false" color="accent" mat-raised-button>ANNULEREN</button>
  <button [mat-dialog-close]="true" color="warn" mat-raised-button>BEVESTIGEN</button>
</mat-dialog-actions>
